import { AiPart } from "@intelligems/ig-types/schemas/ai/ui-message-part";
import { PickType } from "@intelligems/ig-types/utils";
import { StepTimeline } from "@src/components/steps/StepTimeline";

import { WORK_LOG_ICON, WORK_LOG_THOUGHT_LABEL } from "./work-log";

/**
 * A model reasoning part drawn as a work-log thought row on its own ("Thought
 * about this step") instead of the raw streaming reasoning panel. Placeholder
 * or empty reasoning leaves no row.
 */
export const ReasoningStep = ({
  part,
}: {
  part: PickType<AiPart, "reasoning">;
}) => {
  const text = part.text?.trim();
  if (!text || text === "Thinking..." || text.toLowerCase().includes("noop")) {
    return null;
  }

  return (
    <StepTimeline
      steps={[
        {
          id: "thought",
          label: WORK_LOG_THOUGHT_LABEL,
          status: "done",
          icon: WORK_LOG_ICON.thought,
        },
      ]}
    />
  );
};
